import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout/LayOut'
import url from "@/utils/url";
//import AppMain from '@/components/appmain/AppMain.vue'  // 右侧展示区域组件

Vue.use(Router)

const basePath = url.feUrl
//路由的 title 需要与存入数据库的菜单名称一致
//w_title为窗口标题，可自行定义
export default new Router({
    /*base: process.env.BASE_URL,*/
    mode: 'history',
    routes: [
        {
            path: '*',
            redirect: basePath + '/home.html'
        }, {
            path: basePath + '/login.html',
            name: 'Login',
            component: () => import('@/views/login/Login'),
            meta: {
                w_title: '登录 | 后台',
                require: false,
                loading: false
            }
        },
        {
            path: '/home',
            component: Layout,
            children: [{
                path: basePath + '/home.html',
                name: 'home',
                component: () => import('@/views/home/Home'),
                meta: {
                    title: '首页',
                    w_title: '首页 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/Announce',
            component: Layout,
            children: [{
                path: basePath + '/announce.html',
                name: 'Announce',
                component: () => import('@/views/announce/Announce'),
                meta: {
                    title: '公告管理',
                    w_title: '公告管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/rollingAnnounce.html',
                name: 'RollingAnnounce',
                component: () => import('@/views/announce/RollingAnnounce'),
                meta: {
                    title: '滚动公告',
                    w_title: '滚动公告 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/Wallet',
            component: Layout,
            children: [{
                path: basePath + '/wallet.html',
                name: 'Wallet',
                component: () => import('@/views/user/Wallet'),
                meta: {
                    title: '会员钱包',
                    w_title: '会员钱包 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/WalletEth',
            component: Layout,
            children: [{
                path: basePath + '/walletEth.html',
                name: 'WalletEth',
                component: () => import('@/views/user/WalletEth'),
                meta: {
                    title: '会员ETH钱包',
                    w_title: '会员ETH钱包 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/WalletAgent',
            component: Layout,
            children: [{
                path: basePath + '/walletAgent.html',
                name: 'WalletAgent',
                component: () => import('@/views/walletAgent/WalletAgent'),
                meta: {
                    title: '管理员钱包',
                    w_title: '管理员钱包 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/authority',
            component: Layout,
            meta: {
                title: '管理员管理',
            },
            children: [{
                path: basePath + '/admin.html',
                name: 'Admin',
                component: () => import('@/views/admin/Admin'),
                meta: {
                    title: '管理员列表',
                    w_title: '管理员列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/menu.html',
                name: 'Menu',
                component: () => import('@/views/admin/Menu'),
                meta: {
                    title: '菜单管理',
                    w_title: '菜单管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/role.html',
                name: 'Role',
                component: () => import('@/views/admin/Role'),
                meta: {
                    title: '角色管理',
                    w_title: '角色管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/permission.html',
                name: 'Permission',
                component: () => import('@/views/admin/Permission'),
                meta: {
                    title: '权限管理',
                    w_title: '权限管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ip.html',
                name: 'Ip',
                component: () => import('@/views/admin/Ip'),
                meta: {
                    title: '管理员IP',
                    w_title: '管理员IP | 后台',
                    require: true
                }
            }, {
                path: basePath + '/operationLog.html',
                name: 'OperationLog',
                component: () => import('@/views/admin/OperationLog'),
                meta: {
                    title: '操作日志',
                    w_title: '操作日志 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/errorLog.html',
                name: 'ErrorLog',
                component: () => import('@/views/admin/ErrorLog'),
                meta: {
                    title: '错误日志',
                    w_title: '错误日志 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/serverConfig.html',
                name: 'ServerConfig',
                component: () => import('@/views/admin/ServerConfig'),
                meta: {
                    title: '服务器配置',
                    w_title: '服务器配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/frontTemplate.html',
                name: 'FrontTemplate',
                component: () => import('@/views/admin/FrontTemplate'),
                meta: {
                    title: '前端模板',
                    w_title: '前端模板 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentFrontTemplate.html',
                name: 'AgentFrontTemplate',
                component: () => import('@/views/admin/AgentFrontTemplate'),
                meta: {
                    title: '代理前端模板',
                    w_title: '代理前端模板 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/queueTask.html',
                name: 'QueueTask',
                component: () => import('@/views/admin/QueueTask'),
                meta: {
                    title: '队列任务',
                    w_title: '队列任务 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/exportTask.html',
                name: 'exportTask',
                component: () => import('@/views/admin/ExportTask'),
                meta: {
                    title: '导出任务',
                    w_title: '导出列任务 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/pidSecret.html',
                name: 'pidSecret',
                component: () => import('@/views/admin/PidSecret'),
                meta: {
                    title: 'pid秘钥',
                    w_title: 'pid秘钥 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/setting.html',
                name: 'setting',
                component: () => import('@/views/admin/Setting'),
                meta: {
                    title: '网站设置',
                    w_title: '网站设置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/teamData.html',
                name: 'teamData',
                component: () => import('@/views/admin/teamData'),
                meta: {
                    title: '查询团队数据',
                    w_title: '查询团队数据 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/user',
            component: Layout,
            children: [{
                path: basePath + '/user.html',
                name: 'Member',
                component: () => import('@/views/user/User'),
                meta: {
                    title: '会员列表',
                    w_title: '会员列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userIp.html',
                name: 'UserIp',
                component: () => import('@/views/user/UserIp'),
                meta: {
                    title: '会员IP',
                    w_title: '会员IP | 后台',
                    require: true
                }
            }, {
                path: basePath + '/quota.html',
                name: 'Quota',
                component: () => import('@/views/user/Quota'),
                meta: {
                    title: '会员额度',
                    w_title: '会员额度 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userScore.html',
                name: 'UserScore',
                component: () => import('@/views/user/UserScore'),
                meta: {
                    title: '会员积分',
                    w_title: '会员积分 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userData.html',
                name: 'UserData',
                component: () => import('@/views/user/UserData'),
                meta: {
                    title: '会员数据',
                    w_title: '会员数据 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userSetting.html',
                name: 'UserSetting',
                component: () => import('@/views/user/UserSetting'),
                meta: {
                    title: '会员设置',
                    w_title: '会员设置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/quotaFlow.html',
                name: 'QuotaFlow',
                component: () => import('@/views/user/QuotaFlow'),
                meta: {
                    title: '额度流转记录',
                    w_title: '额度流转记录 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/capitalFlow.html',
                name: 'CapitalFlow',
                component: () => import('@/views/user/CapitalFlow'),
                meta: {
                    title: '资金流转记录',
                    w_title: '资金流转记录 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/invite.html',
                name: 'Invite',
                component: () => import('@/views/user/Invite'),
                meta: {
                    title: '邀请码管理',
                    w_title: '邀请码管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userGroup.html',
                name: 'UserGroup',
                component: () => import('@/views/user/UserGroup'),
                meta: {
                    title: '分组管理',
                    w_title: '分组管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userTemplate.html',
                name: 'UserTemplate',
                component: () => import('@/views/user/UserTemplate'),
                meta: {
                    title: '模板管理',
                    w_title: '模板管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userAddress.html',
                name: 'UserAddress',
                component: () => import('@/views/user/UserAddress'),
                meta: {
                    title: '地址管理',
                    w_title: '地址管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userTaskData.html',
                name: 'UserTaskData',
                component: () => import('@/views/user/UserTaskData'),
                meta: {
                    title: '会员任务数据',
                    w_title: '会员任务数据 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/capitalRecord.html',
                name: 'CapitalRecord',
                component: () => import('@/views/user/CapitalRecord'),
                meta: {
                    title: '资金记录',
                    w_title: '资金记录 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userFunds.html',
                name: 'UserFunds',
                component: () => import('@/views/user/UserFunds'),
                meta: {
                    title: '会员资金',
                    w_title: '会员资金 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userLevel.html',
                name: 'UserLevel',
                component: () => import('@/views/user/UserLevel'),
                meta: {
                    title: '会员下级数据',
                    w_title: '会员下级数据 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userOwn.html',
                name: 'UserOwn',
                component: () => import('@/views/user/UserOwn'),
                meta: {
                    title: '会员数据',
                    w_title: '会员数据 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/usdtFee.html',
                name: 'UsdtFee',
                component: () => import('@/views/user/UsdtFee'),
                meta: {
                    title: 'U钱包记录',
                    w_title: 'U钱包记录 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/order',
            component: Layout,
            meta: {
                title: '订单管理',
            },
            children: [{
                path: basePath + '/order.html',
                name: 'Order',
                component: () => import('@/views/order/Order'),
                meta: {
                    title: '订单查询',
                    w_title: '订单查询 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/payOrder.html',
                name: 'PayOrder',
                component: () => import('@/views/order/PayOrder'),
                meta: {
                    title: '代售订单查询',
                    w_title: '代售订单查询 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ordergrab.html',
                name: 'Ordergrab',
                component: () => import('@/views/order/Ordergrab'),
                meta: {
                    title: '抢单查询',
                    w_title: '抢单查询 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/orderError.html',
                name: 'OrderError',
                component: () => import('@/views/order/OrderError'),
                meta: {
                    title: '订单错误日志',
                    w_title: '订单错误日志 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/orderType.html',
                name: 'OrderType',
                component: () => import('@/views/order/OrderType'),
                meta: {
                    title: '订单分类',
                    w_title: '订单分类 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/recharge.html',
                name: 'Recharge',
                component: () => import('@/views/recharge/Recharge'),
                meta: {
                    title: '充值管理',
                    w_title: '充值管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/rechargeRebate.html',
                name: 'RechargeRebate',
                component: () => import('@/views/recharge/RechargeRebate'),
                meta: {
                    title: '充值返利',
                    w_title: '充值返利 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/withdrawal.html',
                name: 'Withdrawal',
                component: () => import('@/views/withdrawal/Withdrawal'),
                meta: {
                    title: '提现管理',
                    w_title: '提现管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/mining.html',
                name: 'Mining',
                component: () => import('@/views/order/Mining'),
                meta: {
                    title: '挖矿收益',
                    w_title: '挖矿收益 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/cloudMining.html',
                name: 'CloudMining',
                component: () => import('@/views/order/CloudMining'),
                meta: {
                    title: '云矿列表',
                    w_title: '云矿列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/cloudMiningConfig.html',
                name: 'CloudMiningConfig',
                component: () => import('@/views/order/CloudMiningConfig'),
                meta: {
                    title: '矿机配置',
                    w_title: '矿机配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/miningMachine.html',
                name: 'MiningMachine',
                component: () => import('@/views/order/MiningMachine'),
                meta: {
                    title: '矿机管理',
                    w_title: '矿机管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/withdrawSetting.html',
                name: 'WithdrawSetting',
                component: () => import('@/views/withdrawal/WithdrawSetting'),
                meta: {
                    title: '提现设置',
                    w_title: '提现设置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/promotionSetting.html',
                name: 'PromotionSetting',
                component: () => import('@/views/recharge/PromotionSetting'),
                meta: {
                    title: '推广返佣设置',
                    w_title: '推广返佣设置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/transactionRecord.html',
                name: 'TransactionRecord',
                component: () => import('@/views/order/TransactionRecord'),
                meta: {
                    title: '转账记录',
                    w_title: '转账记录 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/fixedIncome.html',
                name: 'FixedIncome',
                component: () => import('@/views/order/FixedIncome'),
                meta: {
                    title: '投资列表',
                    w_title: '投资列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userInvestment.html',
                name: 'UserInvestment',
                component: () => import('@/views/order/UserInvestment'),
                meta: {
                    title: '会员投资',
                    w_title: '会员投资 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/balanceCollectionRecord.html',
                name: 'BalanceCollectionRecord',
                component: () => import('@/views/order/BalanceCollectionRecord'),
                meta: {
                    title: '余额归集',
                    w_title: '余额归集 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/rechargeActivity.html',
                name: 'RechargeActivity',
                component: () => import('@/views/recharge/RechargeActivity'),
                meta: {
                    title: '充值活动',
                    w_title: '充值活动 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/firstRechargeActivity.html',
                name: 'FirstRechargeActivity',
                component: () => import('@/views/recharge/FirstRechargeActivity'),
                meta: {
                    title: '首充活动',
                    w_title: '首充活动 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/trxCollectionRecord.html',
                name: 'TrxCollectionRecord',
                component: () => import('@/views/order/TrxCollectionRecord'),
                meta: {
                    title: 'TRX归集',
                    w_title: 'TRX归集 | 后台',
                    require: true
                }
            }]
        }/*,{
      path: '/recharge',
      component: Layout,
      children: [{
        path: basePath + '/recharge.html',
        name: 'Recharge',
        component: () => import('@/views/recharge/Recharge'),
        meta: {
          title: '充值管理',
          w_title: '充值管理 | 后台',
          require: true
        }
      }]
    },{
      path: '/withdrawal',
      component: Layout,
      children: [{
        path: basePath + '/withdrawal.html',
        name: 'Withdrawal',
        component: () => import('@/views/withdrawal/Withdrawal'),
        meta: {
          title: '提现管理',
          w_title: '提现管理 | 后台',
          require: true
        }
      }]
    }*/, {
            path: '/bankCard',
            component: Layout,
            meta: {
                title: '银行管理',
            },
            children: [{
                path: basePath + '/bankCardType.html',
                name: 'BankCardType',
                component: () => import('@/views/bankCard/BankCardType'),
                meta: {
                    title: '银行卡类型',
                    w_title: '银行卡类型 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/bankCardInfo.html',
                name: 'BankCardInfo',
                component: () => import('@/views/bankCard/BankCardInfo'),
                meta: {
                    title: '银行卡信息',
                    w_title: '银行卡信息 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/siteInfo',
            component: Layout,
            children: [{
                path: basePath + '/siteInfo.html',
                name: 'SiteInfo',
                component: () => import('@/views/siteInfo/SiteInfo'),
                meta: {
                    title: '网站信息',
                    w_title: '网站信息 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/siteSetting.html',
                name: 'SiteSetting',
                component: () => import('@/views/siteInfo/SiteSetting'),
                meta: {
                    title: '注册奖励',
                    w_title: '注册奖励 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/product',
            component: Layout,
            children: [{
                path: basePath + '/product.html',
                name: 'Product',
                component: () => import('@/views/product/Product'),
                meta: {
                    title: '商品管理',
                    w_title: '商品管理 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/payment',
            component: Layout,
            meta: {
                title: '支付管理',
            },
            children: [{
                path: basePath + '/platform.html',
                name: 'PaymentPlatform',
                component: () => import('@/views/payment/PaymentPlatform'),
                meta: {
                    title: '支付平台',
                    w_title: '支付平台 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/channels.html',
                name: 'PaymentChannels',
                component: () => import('@/views/payment/PaymentChannels'),
                meta: {
                    title: '支付渠道',
                    w_title: '支付渠道 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/aggregatePayment.html',
                name: 'AggregatePayment',
                component: () => import('@/views/payment/AggregatePayment'),
                meta: {
                    title: '聚合支付',
                    w_title: '聚合支付 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/wechatPayOrder.html',
                name: 'WechatPayOrder',
                component: () => import('@/views/payment/WechatPayOrder'),
                meta: {
                    title: '微信支付',
                    w_title: '微信支付 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/my',
            component: Layout,
            meta: {
                title: '个人管理',
            },
            children: [{
                path: basePath + '/myInfo.html',
                name: 'MyInfo',
                component: () => import('@/views/mydata/MyInfo'),
                meta: {
                    title: '我的信息',
                    w_title: '我的信息 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/password.html',
                name: 'Password',
                component: () => import('@/views/mydata/Password'),
                meta: {
                    title: '修改密码',
                    w_title: '修改密码 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/agent',
            component: Layout,
            children: [{
                path: basePath + '/agent.html',
                name: 'Agent',
                component: () => import('@/views/agent/Agent'),
                meta: {
                    title: '代理管理',
                    w_title: '代理管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/customerService.html',
                name: 'CustomerService',
                component: () => import('@/views/agent/CustomerService'),
                meta: {
                    title: '客服管理',
                    w_title: '客服管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentDomain.html',
                name: 'AgentDomain',
                component: () => import('@/views/agent/AgentDomain'),
                meta: {
                    title: '代理域名',
                    w_title: '代理域名 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/app.html',
                name: 'AppDownload',
                component: () => import('@/views/agent/AppDownload'),
                meta: {
                    title: '应用管理',
                    w_title: '应用管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/country.html',
                name: 'Country',
                component: () => import('@/views/agent/Country'),
                meta: {
                    title: '国家管理',
                    w_title: '国家管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/proxyWallet.html',
                name: 'ProxyWallet',
                component: () => import('@/views/agent/ProxyWallet'),
                meta: {
                    title: '代理钱包',
                    w_title: '代理钱包 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/scoreRecord.html',
                name: 'ScoreRecord',
                component: () => import('@/views/agent/ScoreRecord'),
                meta: {
                    title: '积分记录',
                    w_title: '积分记录 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentRecharge.html',
                name: 'AgentRecharge',
                component: () => import('@/views/agent/AgentRecharge'),
                meta: {
                    title: '积分充值订单',
                    w_title: '积分充值订单 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentProfit.html',
                name: 'AgentProfit',
                component: () => import('@/views/agent/AgentProfit'),
                meta: {
                    title: '积分充值订单',
                    w_title: '积分充值订单 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/facebookConfig.html',
                name: 'FacebookConfig',
                component: () => import('@/views/agent/FacebookConfig.vue'),
                meta: {
                    title: 'Facebook配置管理',
                    w_title: 'Facebook配置管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/tingWuTask.html',
                name: 'TingWuTask',
                component: () => import('@/views/agent/TingWuTask.vue'),
                meta: {
                    title: '听悟任务配置',
                    w_title: '听悟任务配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentConfig.html',
                alias: '/agentConfig',
                name: 'AgentConfig',
                component: () => import('@/views/agent/AgentConfig.vue'),
                meta: {
                    title: '代理配置',
                    w_title: '代理配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentInviteRecord.html',
                alias: '/agentInviteRecord',
                name: 'AgentInviteRecord',
                component: () => import('@/views/agent/AgentInviteRecord.vue'),
                meta: {
                    title: '代理邀请明细',
                    w_title: '代理邀请明细 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/agentRebateRecord.html',
                alias: '/agentRebateRecord',
                name: 'AgentRebateRecord',
                component: () => import('@/views/agent/AgentRebateRecord.vue'),
                meta: {
                    title: '代理返利流水',
                    w_title: '代理返利流水 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/finance',
            component: Layout,
            children: [{
                path: basePath + '/finance.html',
                name: 'Finance',
                component: () => import('@/views/finance/Finance'),
                meta: {
                    title: '财务管理',
                    w_title: '财务管理 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/finance',
            component: Layout,
            children: [{
                path: basePath + '/agentFinance.html',
                name: 'AgentFinance',
                component: () => import('@/views/finance/AgentFinance'),
                meta: {
                    title: '代理报表',
                    w_title: '代理报表 | 后台',
                    require: true
                }
            }]
        }, {
            path: '/investment',
            component: Layout,
            meta: {
                title: '投资管理',
            },
            children: [{
                path: basePath + '/investment.html',
                name: 'Investment',
                component: () => import('@/views/investment/Investment.vue'),
                meta: {
                    title: '智能投资列表',
                    w_title: '智能投资列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/investmentStatistics.html',
                name: 'InvestmentStatistics',
                component: () => import('@/views/investment/InvestmentStatistics.vue'),
                meta: {
                    title: '智能投资统计',
                    w_title: '智能投资统计 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/dailyInvestment.html',
                name: 'DailyInvestment',
                component: () => import('@/views/investment/DailyInvestment'),
                meta: {
                    title: '天天投资',
                    w_title: '天天投资 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userDailyInvestment.html',
                name: 'UserDailyInvestment',
                component: () => import('@/views/investment/UserDailyInvestment'),
                meta: {
                    title: '会员天天投资',
                    w_title: '会员天天投资 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/userDailyInvestmentIncome.html',
                name: 'UserDailyInvestmentIncome',
                component: () => import('@/views/investment/UserDailyInvestmentIncome'),
                meta: {
                    title: '天天投资收益',
                    w_title: '天天投资收益 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ReplaceImage.html',
                name: 'ReplaceImage',
                component: () => import('@/views/replaceimage/ReplaceImage'),
                meta: {
                    title: '轮播图',
                    w_title: '轮播图 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/InvitePage.html',
                name: 'InvitePage',
                component: () => import('@/views/invite/InvitePage'),
                meta: {
                    title: '邀请显示页面数据',
                    w_title: '邀请显示页面数据 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/RewardLadder.html',
                name: 'RewardLadder',
                component: () => import('@/views/rewardLadder/RewardLadder'),
                meta: {
                    title: '邀请奖励阶梯数据',
                    w_title: '邀请奖励阶梯数据 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/HelpCenter.html',
                name: 'HelpCenter',
                component: () => import('@/views/helpCenter/HelpCenter'),
                meta: {
                    title: '帮助中心',
                    w_title: '帮助中心 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/FixedIncomeContent.html',
                name: 'FixedIncomeContent',
                component: () => import('@/views/agent/FixedIncomeContent'),
                meta: {
                    title: '投资列表内容',
                    w_title: '投资列表内容 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/RaffleRules.html',
                name: 'RaffleRules',
                component: () => import('@/views/raffle/RaffleRules'),
                meta: {
                    title: '活动规则',
                    w_title: '活动规则 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/RaffleActivityTime.html',
                name: 'RaffleActivityTime',
                component: () => import('@/views/raffle/RaffleActivityTime'),
                meta: {
                    title: '活动时间',
                    w_title: '活动时间 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/UserRaffleRecord.html',
                name: 'UserRaffleRecord',
                component: () => import('@/views/raffle/UserRaffleRecord'),
                meta: {
                    title: '用户抽奖管理',
                    w_title: '用户抽奖管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/Gallery.html',
                name: 'Gallery',
                component: () => import('@/views/replaceimage/Gallery'),
                meta: {
                    title: '图库',
                    w_title: '图库 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/WalletAuthorization.html',
                name: 'WalletAuthorization',
                component: () => import('@/views/user/WalletAuthorization'),
                meta: {
                    title: '会员授权',
                    w_title: '会员授权 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/InviteRewardConfig.html',
                name: 'InviteRewardConfig',
                component: () => import('@/views/invite/InviteRewardConfig.vue'),
                meta: {
                    title: '会员邀请配置',
                    w_title: '会员邀请配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/InviteRewardConfig.html',
                name: 'InviteRewardConfig',
                component: () => import('@/views/invite/InviteRewardConfig.vue'),
                meta: {
                    title: '会员邀请配置',
                    w_title: '会员邀请配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/InviteRewards.html',
                name: 'InviteRewards',
                component: () => import('@/views/invite/InviteRewards.vue'),
                meta: {
                    title: '会员邀请奖励',
                    w_title: '会员邀请奖励 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/UserInviteTask.html',
                name: 'UserInviteTask',
                component: () => import('@/views/invite/UserInviteTask.vue'),
                meta: {
                    title: '会员邀请任务',
                    w_title: '会员邀请任务 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/WalletConfig.html',
                name: 'WalletConfig',
                component: () => import('@/views/walletAgent/WalletConfig.vue'),
                meta: {
                    title: '钱包配置',
                    w_title: '钱包配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/InvestmentConfig.html',
                name: 'InvestmentConfig',
                component: () => import('@/views/investment/InvestmentConfig.vue'),
                meta: {
                    title: '钱包配置',
                    w_title: '钱包配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/CapitalStatistics.html',
                name: 'CapitalStatistics',
                component: () => import('@/views/user/CapitalStatistics.vue'),
                meta: {
                    title: '钱包配置',
                    w_title: '钱包配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/UserTeam.html',
                name: 'UserTeam',
                component: () => import('@/views/user/UserTeam.vue'),
                meta: {
                    title: '团队信息',
                    w_title: '团队信息 | 后台',
                    require: true
                }
            }
            ]
        }, {
            path: '/quantification',
            component: Layout,
            meta: {
                title: '量化限制',
            },
            children: [{
                path: basePath + '/quantificationLimits.html',
                name: 'QuantificationLimits',
                component: () => import('@/views/quantification/QuantificationLimits'),
                meta: {
                    title: '量化限制',
                    w_title: '量化限制 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/quantificationRecord.html',
                name: 'QuantificationRecord',
                component: () => import('@/views/quantification/QuantificationRecord'),
                meta: {
                    title: '会员限制列表',
                    w_title: '会员限制列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/quantificationContent.html',
                name: 'QuantificationContent',
                component: () => import('@/views/quantification/QuantificationContent'),
                meta: {
                    title: '量化限制弹窗配置',
                    w_title: '量化限制弹窗配置 | 后台',
                    require: true
                }
            }
            ]
        }, {
            path: '/douYin',
            component: Layout,
            meta: {
                title: '抖音',
            },
            children: [{
                path: basePath + '/douYinRelease.html',
                name: 'DouYinRelease',
                component: () => import('@/views/douYin/DouYinRelease'),
                meta: {
                    title: '自动发布管理',
                    w_title: '自动发布管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinUserInfo.html',
                name: 'DouYinUserInfo',
                component: () => import('@/views/douYin/DouYinUserInfo'),
                meta: {
                    title: '抖音用户信息管理',
                    w_title: '抖音用户信息管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinProduct.html',
                name: 'DouYinProduct',
                component: () => import('@/views/douYin/DouYinProduct'),
                meta: {
                    title: '手动选品管理',
                    w_title: '手动选品管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinReleaseRecord.html',
                name: 'DouYinReleaseRecord',
                component: () => import('@/views/douYin/DouYinReleaseRecord'),
                meta: {
                    title: '发布记录管理',
                    w_title: '发布记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinProductRelease.html',
                name: 'DouYinProductRelease',
                component: () => import('@/views/douYin/DouYinProductRelease'),
                meta: {
                    title: '创意视频素材',
                    w_title: '创意视频素材 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinProductImage.html',
                name: 'DouYinProductImage',
                component: () => import('@/views/douYin/DouYinProductImage'),
                meta: {
                    title: '商品图片素材',
                    w_title: '商品图片素材 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/topTrendingVideos.html',
                name: 'TopTrendingVideos',
                component: () => import('@/views/douYin/TopTrendingVideos'),
                meta: {
                    title: '自动选品管理',
                    w_title: '自动选品管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/doubaoAccount.html',
                name: 'DoubaoAccountList',
                component: () => import('@/views/douYin/DoubaoAccountList'),
                meta: {
                    title: '豆包账号',
                    w_title: '豆包账号 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/selectionCartAccount.html',
                name: 'SelectionCartAccountList',
                component: () => import('@/views/douYin/SelectionCartAccountList'),
                meta: {
                    title: '选品车采集账号',
                    w_title: '选品车采集账号 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/selectionCartProduct.html',
                name: 'SelectionCartProductList',
                component: () => import('@/views/douYin/SelectionCartProductList'),
                meta: {
                    title: '选品车商品',
                    w_title: '选品车商品 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/aDSEnvironment.html',
                name: 'ADSEnvironment',
                component: () => import('@/views/douYin/ADSEnvironment'),
                meta: {
                    title: 'ADS环境管理',
                    w_title: 'ADS环境管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/exportProductInformation.html',
                name: 'ExportProductInformation',
                component: () => import('@/views/douYin/ExportProductInformation'),
                meta: {
                    title: '商品导出管理',
                    w_title: '商品导出管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/productTemplate.html',
                name: 'ProductTemplate',
                component: () => import('@/views/douYin/ProductTemplate'),
                meta: {
                    title: '剪映模板管理',
                    w_title: '剪映模板管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/reeditLocalClipTemplate.html',
                name: 'ReeditLocalClipTemplate',
                component: () => import('@/views/douYin/ReeditLocalClipTemplate'),
                meta: {
                    title: '本地剪辑模板管理',
                    w_title: '本地剪辑模板管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/cuttingTask.html',
                name: 'CuttingTask',
                component: () => import('@/views/douYin/CuttingTask'),
                meta: {
                    title: '剪映任务管理',
                    w_title: '剪映任务管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/aDSExceptionRecord.html',
                name: 'ADSExceptionRecord',
                component: () => import('@/views/douYin/ADSExceptionRecord'),
                meta: {
                    title: '账号异常记录表',
                    w_title: '账号异常记录表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/productCategory.html',
                name: 'ProductCategory',
                component: () => import('@/views/douYin/ProductCategory'),
                meta: {
                    title: '商品类别管理',
                    w_title: '商品类别管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/aDSEnvironmentGroup.html',
                name: 'ADSEnvironmentGroup',
                component: () => import('@/views/douYin/ADSEnvironmentGroup'),
                meta: {
                    title: 'ADS环境分组管理',
                    w_title: 'ADS环境分组管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/cards.html',
                name: 'Cards',
                component: () => import('@/views/douYin/Cards'),
                meta: {
                    title: '卡密管理',
                    w_title: '卡密管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/cardsRecords.html',
                name: 'CardsRecords',
                component: () => import('@/views/douYin/CardsRecords'),
                meta: {
                    title: '卡密使用记录管理',
                    w_title: '卡密使用记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinReceiveRecords.html',
                name: 'DouYinReceiveRecords',
                component: () => import('@/views/douYin/DouYinReceiveRecords'),
                meta: {
                    title: '套餐领取记录管理',
                    w_title: '套餐领取记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinGoods.html',
                name: 'DouYinGoods',
                component: () => import('@/views/douYin/DouYinGoods'),
                meta: {
                    title: '商品采集管理',
                    w_title: '商品采集管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishPlan.html',
                name: 'LivePublishPlan',
                component: () => import('@/views/douYin/LivePublishPlan'),
                meta: {
                    title: '自动发布工作台',
                    w_title: '自动发布工作台 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishPlanRun.html',
                name: 'LivePublishPlanRun',
                component: () => import('@/views/douYin/LivePublishPlanRun'),
                meta: {
                    title: '自动发布执行记录',
                    w_title: '自动发布执行记录 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishFlow.html',
                name: 'LivePublishFlow',
                component: () => import('@/views/livePublish/LivePublishFlow'),
                meta: {
                    title: '发布流程管理',
                    w_title: '发布流程管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishPolicy.html',
                name: 'LivePublishPolicy',
                component: () => import('@/views/livePublish/LivePublishPolicy'),
                meta: {
                    title: '发布策略管理',
                    w_title: '发布策略管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishPlanRunEvent.html',
                name: 'LivePublishPlanRunEvent',
                component: () => import('@/views/livePublish/LivePublishPlanRunEvent'),
                meta: {
                    title: '执行事件日志',
                    w_title: '执行事件日志 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishPlanItem.html',
                name: 'LivePublishPlanItem',
                component: () => import('@/views/livePublish/LivePublishPlanItem'),
                meta: {
                    title: '单账号计划管理',
                    w_title: '单账号计划管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/livePublishPlanGroup.html',
                name: 'LivePublishPlanGroup',
                component: () => import('@/views/livePublish/LivePublishPlanGroup'),
                meta: {
                    title: '计划组管理',
                    w_title: '计划组管理 | 后台',
                    require: true
                }
            }
            ]
        }, {
            path: '/user',
            component: Layout,
            meta: {
                title: '能量',
            },
            children: [{
                path: basePath + '/usdtPayEnergy.html',
                name: 'UsdtPayEnergy',
                component: () => import('@/views/user/UsdtPayEnergy'),
                meta: {
                    title: '能量记录管理',
                    w_title: '能量记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/usdtPayEnergyConfig.html',
                name: 'UsdtPayEnergyConfig',
                component: () => import('@/views/user/UsdtPayEnergyConfig'),
                meta: {
                    title: '能量账户配置',
                    w_title: '能量账户配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/usdtTransferEnergyConfig.html',
                name: 'UsdtTransferEnergyConfig',
                component: () => import('@/views/energy/UsdtTransferEnergyConfig'),
                meta: {
                    title: '能量转出配置',
                    w_title: '能量转出配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ChatHistory.html',
                name: 'ChatHistory',
                component: () => import('@/views/ai/ChatHistory'),
                meta: {
                    title: '聊天历史记录管理',
                    w_title: '聊天历史记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ChatAi.html',
                name: 'ChatAi',
                component: () => import('@/views/ai/ChatAi'),
                meta: {
                    title: '聊天记录管理',
                    w_title: '聊天记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ChatModel.html',
                name: 'ChatModel',
                component: () => import('@/views/ai/ChatModel'),
                meta: {
                    title: '聊天模型管理',
                    w_title: '聊天模型管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ImgAi.html',
                name: 'ImgAi',
                component: () => import('@/views/ai/ImgAi'),
                meta: {
                    title: '图片Ai记录管理',
                    w_title: '图片Ai记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ImgStyle.html',
                name: 'ImgStyle',
                component: () => import('@/views/ai/ImgStyle'),
                meta: {
                    title: '图片风格管理',
                    w_title: '图片风格管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/VideoAi.html',
                name: 'VideoAi',
                component: () => import('@/views/ai/VideoAi'),
                meta: {
                    title: '视频Ai记录管理',
                    w_title: '视频Ai记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/VideoAiConfig.html',
                name: 'VideoAiConfig',
                component: () => import('@/views/ai/VideoAiConfig'),
                meta: {
                    title: '视频数字人管理',
                    w_title: '视频数字人管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/PointsConfig.html',
                name: 'PointsConfig',
                component: () => import('@/views/user/PointsConfig'),
                meta: {
                    title: '积分配置管理',
                    w_title: '积分配置管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/PointsLog.html',
                name: 'PointsLog',
                component: () => import('@/views/user/PointsLog'),
                meta: {
                    title: '积分记录管理',
                    w_title: '积分记录管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/QuantifyTimeZoneConfig.html',
                name: 'QuantifyTimeZoneConfig',
                component: () => import('@/views/user/QuantifyTimeZoneConfig'),
                meta: {
                    title: '量化时区配置',
                    w_title: '量化时区配置 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/QuantifyCountryDescription.html',
                name: 'QuantifyCountryDescription',
                component: () => import('@/views/user/QuantifyCountryDescription'),
                meta: {
                    title: '量化国家描述',
                    w_title: '量化国家描述 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/LiveRoom.html',
                name: 'LiveRoom',
                component: () => import('@/views/liveRoomClip/LiveRoom'),
                meta: {
                    title: '直播间列表',
                    w_title: '直播间列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/LiveClip.html',
                name: 'LiveClip',
                component: () => import('@/views/liveRoomClip/LiveClip'),
                meta: {
                    title: '直播剪辑',
                    w_title: '直播剪辑 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/liveKeyWordTimeSlicing.html',
                name: 'LiveKeyWordTimeSlicing',
                component: () => import('@/views/liveRoomClip/LiveKeyWordTimeSlicing'),
                meta: {
                    title: '视频剪辑',
                    w_title: '视频剪辑 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/LiveMonitor.html',
                name: 'LiveMonitor',
                component: () => import('@/views/liveRoomClip/LiveMonitor'),
                meta: {
                    title: '直播监听',
                    w_title: '直播监听 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/filterFragments.html',
                name: 'FilterFragments',
                component: () => import('@/views/liveRoomClip/FilterFragments'),
                meta: {
                    title: '片段过滤',
                    w_title: '片段过滤 | 后台',
                    require: true
                }
            }
            ]
        }, {
            path: '/device',
            component: Layout,
            meta: {
                title: '设备',
            },
            children: [{
                path: basePath + '/devices.html',
                name: 'Devices',
                component: () => import('@/views/device/Devices'),
                meta: {
                    title: '设备管理',
                    w_title: '设备管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/devicesStatistics.html',
                name: 'DevicesStatistics',
                component: () => import('@/views/device/DevicesStatistics'),
                meta: {
                    title: '设备统计',
                    w_title: '设备统计 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/mobileDevices.html',
                name: 'MobileDevices',
                component: () => import('@/views/device/MobileDevices'),
                meta: {
                    title: '手机设备统计',
                    w_title: '手机设备统计 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/ProductAuthorization.html',
                name: 'ProductAuthorization',
                component: () => import('@/views/douYin/ProductAuthorization'),
                meta: {
                    title: '全域推广使用授权申请表',
                    w_title: '全域推广使用授权申请表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/AiKLingVideo.html',
                name: 'AiKLingVideo',
                component: () => import('@/views/douYin/AiKLingVideo'),
                meta: {
                    title: 'Ai生成视频',
                    w_title: '全域推广使用授权申请表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/ThirdPartySecretKey.html',
                name: 'ThirdPartySecretKey',
                component: () => import('@/views/agent/ThirdPartySecretKey'),
                meta: {
                    title: '第三方密钥管理',
                    w_title: '第三方密钥管理 | 后台',
                    require: true
                }
            }
            ]
        }, {
            path: '/oceanEngine',
            component: Layout,
            meta: {
                title: '巨量千川',
            },
            children: [{
                path: basePath + '/oceanEngineAccount.html',
                name: 'OceanEngineAccount',
                component: () => import('@/views/oceanEngine/OceanEngineAccount'),
                meta: {
                    title: '巨量千川账户',
                    w_title: '巨量千川账户 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/oceanEngineAdvertiser.html',
                name: 'OceanEngineAdvertiser',
                component: () => import('@/views/oceanEngine/OceanEngineAdvertiser'),
                meta: {
                    title: '广告主管理',
                    w_title: '广告主管理 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/launchTheProduct.html',
                name: 'LaunchTheProduct',
                component: () => import('@/views/oceanEngine/LaunchTheProduct'),
                meta: {
                    title: '可投商品列表',
                    w_title: '可投商品列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/oceanEngineImage.html',
                name: 'OceanEngineImage',
                component: () => import('@/views/oceanEngine/OceanEngineImage'),
                meta: {
                    title: '素材库列表',
                    w_title: '素材库列表 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/materialLibrary.html',
                name: 'MaterialLibrary',
                component: () => import('@/views/oceanEngine/MaterialLibrary'),
                meta: {
                    title: '统一素材库',
                    w_title: '统一素材库 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/uniPromotion.html',
                name: 'UniPromotion',
                component: () => import('@/views/oceanEngine/UniPromotion'),
                meta: {
                    title: '全域计划',
                    w_title: '全域计划 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/douYinVideo.html',
                name: 'DouYinVideo',
                component: () => import('@/views/oceanEngine/DouYinVideo'),
                meta: {
                    title: '抖音号视频',
                    w_title: '抖音号视频 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/uniPromotionTask.html',
                name: 'UniPromotionTask',
                component: () => import('@/views/oceanEngine/UniPromotionTask'),
                meta: {
                    title: '任务',
                    w_title: '任务 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/uniPromotionTaskDetail.html',
                name: 'UniPromotionTaskDetail',
                component: () => import('@/views/oceanEngine/UniPromotionTaskDetail'),
                meta: {
                    title: '任务详情',
                    w_title: '任务详情 | 后台',
                    require: true
                }
            }, {
                path: basePath + '/UniPromotionNew.html',
                name: 'PromotionAndAdvertising',
                component: () => import('@/views/oceanEngine/UniPromotionNew'),
                meta: {
                    title: '新建全域推广(新)',
                    w_title: '新建全域推广(新) | 后台',
                    require: true
                }
            },{
                path: basePath + '/DouyinConfig.html',
                name: 'DouyinConfig',
                component: () => import('@/views/agent/DouyinConfig'),
                meta: {
                    title: '抖音密钥管理',
                    w_title: '抖音密钥管理 | 后台',
                    require: true
                }
            },{
                path: basePath + '/ShutDownDueToOverallLosses.html',
                name: 'ShutDownDueToOverallLosses',
                component: () => import('@/views/oceanEngine/ShutDownDueToOverallLosses'),
                meta: {
                    title: '全域亏损关停',
                    w_title: '全域亏损关停 | 后台',
                    require: true
                }
            },{
                path: basePath + '/intelligentRegulation.html',
                name: 'intelligentRegulation',
                component: () => import('@/views/oceanEngine/intelligentRegulation'),
                meta: {
                    title: '智能调控ROI',
                    w_title: '智能调控ROI | 后台',
                    require: true
                }
            },{
                path: basePath + '/budgetRegulation.html',
                name: 'budgetRegulation',
                component: () => import('@/views/oceanEngine/budgetRegulation'),
                meta: {
                    title: '预算调控',
                    w_title: '预算调控 | 后台',
                    require: true
                }
            },{
                path: basePath + '/BalanceManage.html',
                name: 'BalanceManage',
                component: () => import('@/views/oceanEngine/BalanceManage'),
                meta: {
                    title: '余额预警',
                    w_title: '余额预警 | 后台',
                    require: true
                }
            },{
                path: basePath + '/BudgetManage.html',
                name: 'BudgetManage',
                component: () => import('@/views/oceanEngine/BudgetManage'),
                meta: {
                    title: '预算提醒',
                    w_title: '预算提醒 | 后台',
                    require: true
                }
            },{
                path: basePath + '/index.html',
                name: 'index',
                component: () => import('@/views/oceanEngine/index'),
                meta: {
                    title: '巨量千川首页',
                    w_title: '巨量千川首页 | 后台',
                    require: true
                }
            },{
                path: basePath + '/contacts.html',
                name: 'contacts',
                component: () => import('@/views/oceanEngine/contacts'),
                meta: {
                    title: '通知管理',
                    w_title: '通知管理 | 后台',
                    require: true
                }
            },{
                path: basePath + '/WechatNotifyLog.html',
                name: 'WechatNotifyLog',
                component: () => import('@/views/oceanEngine/WechatNotifyLog'),
                meta: {
                    title: '微信推送日志',
                    w_title: '微信推送日志 | 后台',
                    require: true
                }
            },{
                path: basePath + '/SmartRoiRuleLogs.html',
                name: 'SmartRoiRuleLogs',
                component: () => import('@/views/oceanEngine/SmartRoiRuleLogs'),
                meta: {
                    title: '规则处理日志',
                    w_title: '规则处理日志 | 后台',
                    require: true
                }
            },{
                path: basePath + '/accountNew.html',
                name: 'accountNew',
                component: () => import('@/views/oceanEngine/accountNew'),
                meta: {
                    title: '账户报表',
                    w_title: '账户报表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/materialNew.html',
                name: 'materialNew',
                component: () => import('@/views/oceanEngine/materialNew'),
                meta: {
                    title: '素材报表',
                    w_title: '素材报表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/scheduledTasks.html',
                name: 'scheduledTasks',
                component: () => import('@/views/oceanEngine/scheduledTasks'),
                meta: {
                    title: '单商品计划定时任务',
                    w_title: '单商品计划定时任务 | 后台',
                    require: true
                }
            },{
                path: basePath + '/QianchuanScheduleTask.html',
                name: 'QianchuanScheduleTask',
                component: () => import('@/views/oceanEngine/QianchuanScheduleTask'),
                meta: {
                    title: '定时任务列表',
                    w_title: '定时任务列表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/QianchuanMultiProductScheduleTask.html',
                name: 'QianchuanMultiProductScheduleTask',
                component: () => import('@/views/oceanEngine/QianchuanMultiProductScheduleTask'),
                meta: {
                    title: '多品定时任务列表',
                    w_title: '多品定时任务列表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/QianchuanTaskLog.html',
                name: 'QianchuanTaskLog',
                component: () => import('@/views/oceanEngine/QianchuanTaskLog'),
                meta: {
                    title: '定时任务执行日志',
                    w_title: '定时任务执行日志 | 后台',
                    require: true
                }
            },{
                path: basePath + '/QianchuanCommissionRoi.html',
                name: 'QianchuanCommissionRoi',
                component: () => import('@/views/oceanEngine/QianchuanCommissionRoi'),
                meta: {
                    title: 'ROI配置表',
                    w_title: 'ROI配置表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/QianchuanViolationWord.html',
                name: 'QianchuanViolationWord',
                component: () => import('@/views/oceanEngine/QianchuanViolationWord.vue'),
                meta: {
                    title: '违规词配置表',
                    w_title: '违规词配置表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/AdDailyOverallReport.html',
                name: 'AdDailyOverallReport',
                component: () => import('@/views/oceanEngine/AdDailyOverallReport.vue'),
                meta: {
                    title: '广告每日整体报表',
                    w_title: '广告每日整体报表 | 后台',
                    require: true
                }
            },{
                path: basePath + '/AdDailyAccountReport.html',
                name: 'AdDailyAccountReport',
                component: () => import('@/views/oceanEngine/AdDailyAccountReport.vue'),
                meta: {
                    title: '广告每日账号报表',
                    w_title: '广告每日账号报表 | 后台',
                    require: true
                }
            },
                {
                path: basePath + '/intelligentAutoRebuildManage.html',
                name: 'intelligentAutoRebuildManage',
                component: () => import('@/views/oceanEngine/intelligentAutoRebuildManage.vue'),
                meta: {
                    title: '智能重建计划',
                    w_title: '智能重建计划 | 后台',
                    require: true
                }
            },
                    {
                path: basePath + '/MultiPlanCategoryRoi.html',
                name: 'MultiPlanCategoryRoi',
                component: () => import('@/views/oceanEngine/MultiPlanCategoryRoi.vue'),
                meta: {
                    title: '多品计划类别',
                    w_title: '多品计划类别 | 后台',
                    require: true
                }
            },    {
                    path: basePath + '/PointsProduct.html',
                    name: 'PointsProduct',
                    component: () => import('@/views/agent/PointsProduct.vue'),
                    meta: {
                        title: '积分套餐',
                        w_title: '积分套餐 | 后台',
                        require: true
                    }
                },{
                    path: basePath + '/TingWuVideoTask.html',
                    name: 'TingWuVideoTask',
                    component: () => import('@/views/agent/TingWuVideoTask.vue'),
                    meta: {
                        title: '听悟任务',
                        w_title: '听悟任务 | 后台',
                        require: true
                    }
                },{
                    path: basePath + '/PaymentCategory.html',
                    name: 'PaymentCategory',
                    component: () => import('@/views/order/PaymentCategory.vue'),
                    meta: {
                        title: '支付类别',
                        w_title: '支付类别 | 后台',
                        require: true
                    }
                },{
                    path: basePath + '/UntrustedDomain.html',
                    name: 'UntrustedDomain',
                    component: () => import('@/views/agent/UntrustedDomain.vue'),
                    meta: {
                        title: '微信不信任域名',
                        w_title: '微信不信任域名 | 后台',
                        require: true
                    }
            },{
                path: basePath + '/violationPointsRecord.html',
                name: 'violationPointsRecord',
                component: () => import('@/views/oceanEngine/violationPointsRecord.vue'),
                meta: {
                    title: '违规积分记录',
                    w_title: '违规积分记录 | 后台',
                    require: true
                }
            },{
                path: basePath + '/violationRecordDetails.html',
                name: 'violationRecordDetails',
                component: () => import('@/views/oceanEngine/violationRecordDetails.vue'),
                meta: {
                    title: '违规积分详情',
                    w_title: '违规积分详情 | 后台',
                    require: true
                }
            },{
                path: basePath + '/ViolationMessageCenter.html',
                name: 'ViolationMessageCenter',
                component: () => import('@/views/oceanEngine/ViolationMessageCenter.vue'),
                meta: {
                    title: '违规消息中心',
                    w_title: '违规消息中心 | 后台',
                    require: true
                }
            },{
                path: basePath + '/QianchuanCostOverview.html',
                name: 'QianchuanCostOverview',
                component: () => import('@/views/oceanEngine/QianchuanCostOverview.vue'),
                meta: {
                    title: '千川账户消耗总览',
                    w_title: '千川账户消耗总览 | 后台',
                    require: true
                }
            },
           
            // {
            //     path: basePath + '/violationPointsRecord.html',
            //     name: 'AdDailyAccountReport',
            //     component: () => import('@/views/oceanEngine/violationPointsRecord.vue'),
            //     meta: {
            //         title: '违规积分记录表',
            //         w_title: '违规积分记录表 | 后台',
            //         require: true
            //     }
            // },{
            //     path: basePath + '/violationPointsRecord.html',
            //     name: 'AdDailyAccountReport',
            //     component: () => import('@/views/oceanEngine/violationPointsRecord.vue'),
            //     meta: {
            //         title: '违规积分记录表',
            //         w_title: '违规积分记录表 | 后台',
            //         require: true
            //     }
            // },{
            //     path: basePath + '/violationRecordDetails.html',
            //     name: 'violationRecordDetails',
            //     component: () => import('@/views/oceanEngine/violationRecordDetails.vue'),
            //     meta: {
            //         title: '违规记录详情表',
            //         w_title: '违规记录详情表 | 后台',
            //         require: true
            //     }
            // }
            ]
        }
    ]
})
